var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ban-form',{attrs:{"title":"Ban Client","ban":_vm.form},on:{"addban":_vm.banClient}})}
var staticRenderFns = []

export { render, staticRenderFns }